import React from "react";
import { useParams } from "react-router-dom";
import {latLngBounds} from 'leaflet';
import { MapContainer, TileLayer, Popup,CircleMarker, useMap, FeatureGroup } from 'react-leaflet'
import { FullscreenControl } from "react-leaflet-fullscreen";
import "react-leaflet-fullscreen/dist/styles.css";
// import { Link } from "react-router-dom";

const ChangeView = (data) =>{
	const map = useMap();
	if(data?.markers?.length > 0){
		// map.setView({lng:data.center.lon, lat : data.center.lat}, 10);
		let markerBounds = latLngBounds([]);
		data?.markers?.forEach(marker => {
			markerBounds.extend([marker.lat, marker.lon])
		});
		map.fitBounds(markerBounds);
		map.scrollWheelZoom.enable()
	}
	return null
}


const DetailMap = (dataProps) => {
  let params = useParams();
  const markers = []
	dataProps?.dataKabkot?.forEach((data)=>{
		markers.push({
			id_provinsi:data?.id_provinsi,
			nama_provinsi:data?.nama_provinsi,
			id_kabkot:data?.id_kabkot,
			nama_kab_kot:data?.nama_kab_kot,
			jumlah_anggota:data?.jumlah_anggota,
			jumlah_penduduk:data?.jumlah_penduduk,
			target_pb:data?.target_pb,
			target_kpu:data?.target_kpu,
			lat:data?.latitude,
			lon:data?.longitude,
			sk_pengurus:data?.info_dokumen?.dokumen_sk_pengurus,
			jumlah_pengurus:data?.jumlah_pengurus_kabkot,
			is_verified : data?.is_verified,
    	is_locked : data?.is_locked,
		})
	})

	const persentase = (penyebut,pembagi) =>{
		let persen = 0
		if(parseInt(pembagi) !== 0 && parseInt(penyebut) !== 0){
			persen = ((parseInt(penyebut)/parseInt(pembagi))*100).toFixed(0)
		}
		return persen
	}

	const hasil = (data) =>{
    let result = "TMS"
    // if(data.jumlah_pengurus > 0 && data?.sk_pengurus === 1 && data.jumlah_anggota >= data.target_pb){
		if(data?.is_verified === 1 && data.jumlah_anggota >= data.target_pb){
      result = "MS"
    }
    return result
  }
	
	const center = {lat:-6.1754354, lon:106.8285582}

	return (
    <div>
      <MapContainer zoom={13} scrollWheelZoom={'true'}>
				<ChangeView center={center} markers={markers} />
        <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
				<FullscreenControl />
				<FeatureGroup >
					{markers.map((marker,index)=>{
						return (
							<CircleMarker
								center={[marker.lat, marker.lon]}
								pathOptions={
									// (params?.tingkatExcoId === "4")?{ color: 'green' }:
									// (parseInt(persentase(marker.jumlah_anggota,marker.target_pb))>=100)?{ color: 'blue' }:
									// (parseInt(persentase(marker.jumlah_anggota,marker.target_pb))>=50 && parseInt(persentase(marker.jumlah_anggota,marker.target_pb))<100)?{ color: 'yellow' }:
									// { color: 'red' }
									(hasil(marker) === "MS")?{ color: 'blue' }:
									// (marker.jumlah_pengurus > 0 && marker?.sk_pengurus === 1)?{ color: 'yellow' }:
									(marker.is_verified === 1)?{ color: 'yellow' }:
									((marker?.jumlah_anggota - marker?.target_pb) >= 0)?{ color: 'orange' }:
									{ color: 'red' }
								}
								radius={10}
								key={index}
							>
								{/* <Tooltip direction="bottom" offset={[0, 0]} opacity={0.7} permanent>
									{marker.nama_provinsi}
								</Tooltip> */}
								
										<Popup>
											<div className="map-popup">
												<span>Provinsi : </span> <b>{marker.nama_provinsi}</b><br />
												<span>Kab/Kota : </span> <b>{marker.nama_kab_kot}</b><br /><br/>
												Keberadaan EXCO : <b>{(marker.is_verified)? "Ada" : "Tidak Ada"}</b><br />
												Kelengkapan EXCO : <b>{(marker.sk_pengurus === 1 && marker.jumlah_pengurus > 0)? "Lengkap" : "Belum Lengkap"}</b><br /><br />
												Jumlah Penduduk : <b>{parseInt(marker.jumlah_penduduk)?.toLocaleString().replace(/,/g,".",)}</b><br />
												Target PB : <b>{parseInt(marker.target_pb)?.toLocaleString().replace(/,/g,".",)}</b><br />
												Standar KPU : <b>{parseInt(marker.target_kpu)?.toLocaleString().replace(/,/g,".",)}</b><br /><br/>
												Jumlah Anggota : <b>{parseInt(marker.jumlah_anggota)?.toLocaleString().replace(/,/g,".",)}</b><br />
												Capaian Target PB: <b>{persentase(marker.jumlah_anggota,marker.target_pb)}%</b> (
                        {((marker?.jumlah_anggota - marker?.target_pb) > 0)?"+":""}{(marker?.jumlah_anggota - marker?.target_pb)?.toLocaleString().replace(/,/g,".",)}
                      	)<br/>
												Capaian Standar KPU : <b>{persentase(marker.jumlah_anggota,marker.target_kpu)}%</b> (
                        {((marker?.jumlah_anggota - marker?.target_kpu) > 0)?"+":""}{(marker?.jumlah_anggota - marker?.target_kpu)?.toLocaleString().replace(/,/g,".",)}
                      	)<br/><br/>
												Hasil : <b>{hasil(marker)}</b>
												{/* <br /><br/>
												<Grid container spacing={0}>
													<Grid item xs={6} sm={6} md={6}>
														<Link to={'/anggota/2/0/0'}>
															<div style={{backgroundColor:'#f2f2f2', display:'inline-block', padding:'4px 8px', borderRadius:'4px'}}>
																Kembali
															</div>
														</Link>
													</Grid>
													<Grid item xs={6} sm={6} md={6} style={{textAlign:'right'}}>
														<Link to={'/anggota/4/'+marker.id_provinsi+'/'+marker.id_kabkot}>
															<div style={{backgroundColor:'#f2f2f2', display:'inline-block', padding:'4px 8px', borderRadius:'4px'}}>
																Telusuri
															</div>
														</Link>
													</Grid>
												</Grid> */}
											</div>
										</Popup>
									
								
							</CircleMarker>
						)
					})}
				</FeatureGroup>
    	</MapContainer>
			<div style={{
				position:"absolute", 
				backgroundColor:'rgba(255,255,255,0.4)',
				marginTop:'-105px',
				marginLeft:'10px',
				zIndex:1000
				}}>
				{(params?.tingkatExcoId !== "4")?
				<table>
					{/* <tbody>
						<tr>
							<td><div style={{backgroundColor:'blue', width: '10px', height :'10px'}}></div></td>
							<td><span style={{fontSize:10}}>Persentase target {'>='} 100%</span></td>
						</tr>
						<tr>
							<td><div style={{backgroundColor:'yellow', width: '10px', height :'10px'}}></div></td>
							<td><span style={{fontSize:10}}>Persentase target 50%-99% </span></td>
						</tr>
						<tr>
							<td><div style={{backgroundColor:'red', width: '10px', height :'10px'}}></div></td>
							<td><span style={{fontSize:10}}>Persentase target {'<'} 50% </span></td>
						</tr>
					</tbody> */}
					<tbody>
						<tr>
							<td><div style={{backgroundColor:'blue', width: '10px', height :'10px'}}></div></td>
							<td><span style={{fontSize:10}}>Memenuhi Syarat (Keberadaan Exco dan Target PB)</span></td>
						</tr>
						<tr>
							<td><div style={{backgroundColor:'yellow', width: '10px', height :'10px'}}></div></td>
							<td><span style={{fontSize:10}}>Ada Exco Saja</span></td>
						</tr>
						<tr>
							<td><div style={{backgroundColor:'orange', width: '10px', height :'10px'}}></div></td>
							<td><span style={{fontSize:10}}>Memenuhi Target PB Saja</span></td>
						</tr>
						<tr>
							<td><div style={{backgroundColor:'red', width: '10px', height :'10px'}}></div></td>
							<td><span style={{fontSize:10}}>Tidak Memenuhi Syarat</span></td>
						</tr>
					</tbody>
				</table>
				:null}
			</div>
    </div>
  );
};

export default DetailMap;
